export default function ComparisonTable() {
  const rows = [
    { feature: 'Product Discovery', basetao: 'Curated spreadsheets with real finds', traditional: 'Manual searching across platforms' },
    { feature: 'Organization', basetao: 'Pre-sorted by category, price, and quality', traditional: 'Bookmarks and scattered notes' },
    { feature: 'Price Tracking', basetao: 'Community-updated pricing data', traditional: 'Manual price checks per item' },
    { feature: 'Community Data', basetao: 'Real reviews and QC photos shared', traditional: 'Relies on seller images only' },
    { feature: 'Beginner Friendly', basetao: 'Step-by-step guides for new users', traditional: 'Steep learning curve, no guidance' },
    { feature: 'Shipping Clarity', basetao: 'Transparent cost breakdowns by carrier', traditional: 'Hidden fees and surprise charges' },
  ];

  return (
    <section id="comparison" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold tracking-wide uppercase mb-4">
            At a Glance
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Basetao Spreadsheet <span className="italic text-secondary-600 font-normal">vs</span> Traditional Search
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base leading-relaxed">
            See how using a structured Basetao Spreadsheet transforms your shopping workflow compared to the old way of doing things.
          </p>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
          <div className="grid grid-cols-3 bg-background-200/50 border-b border-background-200/60">
            <div className="px-5 py-4 text-sm font-semibold text-foreground-700">Feature</div>
            <div className="px-5 py-4 text-sm font-semibold text-primary-700 flex items-center gap-1.5">
              <i className="ri-sparkling-line text-xs"></i> Basetao Spreadsheet
            </div>
            <div className="px-5 py-4 text-sm font-semibold text-foreground-500">Traditional Search</div>
          </div>
          {rows.map((row, i) => (
            <div
              key={row.feature}
              className={`grid grid-cols-3 border-b border-background-200/40 last:border-b-0 ${
                i % 2 === 0 ? 'bg-transparent' : 'bg-background-100/50'
              }`}
            >
              <div className="px-5 py-3.5 text-sm font-medium text-foreground-800">{row.feature}</div>
              <div className="px-5 py-3.5 text-sm text-primary-700 flex items-center gap-1.5">
                <i className="ri-check-line text-green-500 text-xs"></i>
                {row.basetao}
              </div>
              <div className="px-5 py-3.5 text-sm text-foreground-500 flex items-center gap-1.5">
                <i className="ri-close-line text-red-400 text-xs"></i>
                {row.traditional}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}